<template>
  <nav v-if="totalPage > 1" class="paginator" :aria-label="$t('pagination.label')">
    <ul class="paginator__list">
      <!-- Previous button -->
      <li class="paginator__item paginator__item--arrow">
        <button
          type="button"
          class="paginator__btn paginator__arrow"
          :disabled="currentPage <= 1"
          :aria-label="$t('pagination.prev')"
          @click="$emit('prev-page')"
        >
          <span class="material-icons" aria-hidden="true">chevron_left</span>
        </button>
      </li>

      <!-- Page buttons from window -->
      <template v-for="item in items" :key="item.key">
        <li v-if="item.type === 'page'" :class="['paginator__item', 'paginator__item--page', {
          'paginator__item--current': item.current,
          'paginator__item--edge': item.edge,
          'paginator__item--sibling': !item.current && !item.edge
        }]">
          <button
          type="button"
            class="paginator__btn paginator__page"
            :class="{
              'paginator__page--current': item.current,
              'paginator__page--edge': item.edge,
              'paginator__page--sibling': !item.current && !item.edge
            }"
            :aria-current="item.current ? 'page' : undefined"
            @click="$emit('change-page', item.page)"
          >
            {{ item.page }}
          </button>
        </li>
        <li v-else class="paginator__item paginator__item--ellipsis">
          <span class="paginator__ellipsis" aria-hidden="true">…</span>
        </li>
      </template>

      <!-- Status text (visible only on narrow screens) -->
      <li class="paginator__item paginator__item--status">
        <span class="paginator__status">
          {{ $t('pagination.pageOf', { current: currentPage, total: totalPage }) }}
        </span>
      </li>

      <!-- Next button -->
      <li class="paginator__item paginator__item--arrow">
        <button
          type="button"
          class="paginator__btn paginator__arrow"
          :disabled="currentPage >= totalPage"
          :aria-label="$t('pagination.next')"
          @click="$emit('next-page')"
        >
          <span class="material-icons" aria-hidden="true">chevron_right</span>
        </button>
      </li>
    </ul>
  </nav>
</template>

<script>
// nome multi-parola richiesto da eslint (defineOptions non è riconosciuto dalla config del progetto)
export default {
  name: "TablePaginator",
};
</script>

<script setup>
import { usePageWindow } from "@/composables/lists/usePageWindow.js";
import "@/assets/scss/Paginator.scss";

const props = defineProps({
  totalPage: Number,
  currentPage: Number,
});

defineEmits(["prev-page", "next-page", "change-page"]);

const { items } = usePageWindow(() => props.totalPage, () => props.currentPage);
</script>
